import React from 'react';
import moment from 'moment';
import { useCurrentUser, useTranslate } from '@hooks';
import { Alert } from '@dotone/react-ui-core';

const formatSubscriptionDate = (date) => {
  return date ? moment(date).format('YYYY/MM/DD') : '';
};

const MarketplaceInviteInfoAlert = () => {
  const { tHtml } = useTranslate('common', 'hints');
  const { currentUser } = useCurrentUser();

  return (
    <Alert variant="warning">
      {tHtml('resetSubscription', {
        count: currentUser.marketplaceInvitesAvailable,
        resetDate: formatSubscriptionDate(currentUser.subscriptionResetDate),
      })}
    </Alert>
  );
};

export default MarketplaceInviteInfoAlert;
